/**
 * 热点聚焦左侧
 * 2017-11-19
 * Bai.Zhiming
 */
'use strict';
angular.module('hotFocusLeftModule', []).directive('hotFocusLeft', [
    '$state',
    '$timeout',
    '$q',
    'trsHttpService',
    'trsHttpService',
    function($state, $timeout, $q, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './planningCenter/hotFocus/left/left_tpl.html',
            scope: {
                selected: '=',
            },
            link: function(scope, $elem, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        expanded: false,
                        expandedLeve2: '',
                    };
                    // getPermission();
                    autoLocation();
                }

                /**
                 * [autoLocation description] 自动定位
                 * @return  {[type]}  [return description]
                 */
                function autoLocation() {
                    scope.$watch('selected', (newV, oldV) => {
                        if (newV === 'hotfocus') {
                            scope.status.expanded = true;
                            let routerName = $state.current.name;
                            let routerArray = routerName.split('.');
                            if ($state.current.name != 'front.plan.hotfocus') {
                                scope.status.expandedLeve2 = routerArray[3];
                                scope.status.selectedLeve3 = routerArray[3] + '.' + routerArray[4];
                                if (routerArray.length === 4) {
                                    scope.$root.narrowNavigation = true;
                                }
                            }
                        } else {
                            scope.status.expandedLeve2 = '';
                        }
                    });
                }

                // /**
                //  * [getPermission description] 获取权限
                //  * @return {[type]} [description]
                //  */
                // function getPermission() {
                //     var deffer = $q.defer();
                //     var params = {
                //         typeid: 'widget',
                //         serviceid: 'tenantMgr',
                //         modelid: 'show',
                //     };
                //     trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                //         scope.status.rights = data;
                //         deffer.resolve(scope.status);
                //     });

                //     return deffer.promise;
                // }

                /**
                 * [expandLeve2 description] 展开二级
                 * @param   {[type]}  type    [type description] 类型名称
                 * @param   {[type]}  $event  [$event description]
                 * @return  {[type]}          [return description]
                 */
                scope.expandLeve2 = function(type, $event) {
                    scope.status.expandedLeve2 = type;
                    $timeout(() => {
                        $($event.currentTarget)
                            .next('ul')
                            .find('a')[0]
                            .click();
                        scope.$root.narrowNavigation = false;
                    });
                };

                /**
                 * [selectLeve3 description] 选中三级
                 * @param  {[type]} routerNamePart [description] 路由名称
                 * @return {[type]}            [description]
                 */
                scope.selectLeve3 = function(routerNamePart) {
                    let routerName = 'front.plan.hotfocus.' + routerNamePart;
                    $state.go(routerName, {}, { reload: routerName });
                    scope.status.selectedLeve3 = routerNamePart;
                    if (scope.selected !== 'hotfocus') {
                        $timeout(() => {
                            scope.selected = 'hotfocus';
                        }, 500);
                    }
                };

                /**
                 * [selectRegionalHotSpots description] 选中区县热点
                 * @return {[type]} [description]
                 */
                scope.selectRegionalHotSpots = function() {
                    let routerName = 'front.plan.hotfocus.regionalhotspots.countyHotSpots';
                    $state.go(routerName, { district: scope.status.rights.district }, { reload: routerName });
                    scope.status.selectedLeve3 = 'regionalhotspots.countyHotSpots';
                    if (scope.selected !== 'hotfocus') {
                        $timeout(() => {
                            scope.selected = 'hotfocus';
                        }, 500);
                    }
                };

                /**
                 * [selectLeve2 description] 选中二级
                 * @param  {[type]} routerNamePart [description] 路由名称
                 * @return {[type]}            [description]
                 */
                scope.selectLeve2 = function(routerNamePart) {
                    scope.status.expandedLeve2 = routerNamePart;
                    $state.go('front.plan.hotfocus.' + routerNamePart, '', { reload: 'front.plan.hotfocus.' + routerNamePart });
                    scope.$root.narrowNavigation = true;
                    if (scope.selected !== 'hotfocus') {
                        $timeout(() => {
                            scope.selected = 'hotfocus';
                        }, 500);
                    }
                };
            },
        };
    },
]);
